import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Components
import Loading from '../../../../components/Loading/Loading';
import MainCard from '../../../../components/MainCard/MainCard';
import TextField from '../../../../components/TextField/TextField';

//Helpers
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';

//Api
import relatorio_api from '../../../../api/relatorio_api';
import setor_api from 'api/setor_api';
import ramoDeAtividade_api from 'api/ramoDeAtividade_api';

import FiltroPrefeitura from 'views/Shared/FiltroPrefeitura';
import RelatorioGeradores from './GeradoresRelatorioFicha';
function initialStateFiltros() {
  return {
    status: "Todos",
    regionalId: 0,
    regionalId_selected: { value: null, label: "Todos" },
    RamoAtividade: null,
    RamoAtividade_selected: { value: null, label: "Todos" },
    nomeRelatorio: "Relatórios - Geradores"
  }
}

function GeradoresRelatorio() {
  //Estado que valida os possiveis erros nos campos de filtros
  const [errors, setErrors] = useState({});

  //Guarda os filtros obrigatorios
  const campos = [
    objCampo({ name: "status", required: true }),
  ];

  //Estado de controle do loading na tela
  const [loading, setLoading] = useState();

  //Estado que guarda os valores dos filtros
  const [filtros, setFiltros] = useState(initialStateFiltros());

  //Opções de regionais
  const [optionsRegionais, setOptionsRegionais] = useState([]);

  //Estado que guarda os dados do relatorio
  const [dadosRelatorio, setDadosRelatorio] = useState(null);

  //Estado que guarda as opções dos ramos de atividade
  const [optionsRamos, setOptionsRamos] = useState([]);

  //Opções do select de status
  const optionsStatus = [
    { value: "Todos", text: "Todos" },
    { value: "Ativo", text: "Ativo" },
    { value: "Inativo", text: "Inativo" },
  ]

  //Change para os campos de select
  const onChangeSelected = (e, select) => {
    const { name } = select;
    const fieldName = name.split("_")[0];
    // Se o campo termina com "Id", usa 0 quando vazio, senão usa null
    const emptyValue = fieldName.endsWith("Id") ? 0 : null;
    const finalValue = (e && e.value !== null && e.value !== undefined) ? e.value : emptyValue;

    setFiltros({
      ...filtros,
      [name]: e,
      [fieldName]: finalValue
    });
  }

  //Change para os campos de filtro
  const onChangeFiltros = (e) => {
    const { name, value } = e.target;
    setFiltros({
      ...filtros,
      [name]: value
    })
  }

  //Variavel de navegação na tela
  const navigate = useNavigate();

  const loadRegionais = (prefeitura_id) => {
    setor_api.GetListFiltro(prefeitura_id).then(response => {
      response.data = response.data.map(value => {
        return { value: value.id, label: value.descricao }
      })
      setOptionsRegionais([{ value: null, label: "Todos" }, ...response.data]);

    }).catch(e => {
      showMessage("Aviso", e.message, "error", null);
    })
  }

  //Função que faz o controle do id da prefeitura e carrega as regionais
  const handlePrefeitura = (value) => {
    loadRegionais(value);
    loadRamosDeAtividade();
  }

  //Função que carrega a lista de ramos de atividade
  const loadRamosDeAtividade = () => {
    setLoading(true);
    ramoDeAtividade_api.GetList().then(response => {
      response.data = response.data.map(value => { return { label: value.descricao, value: value.descricao } });
      setOptionsRamos([{ value: null, label: "Todos" }, ...response.data]);
    }).catch(e => showMessage("Aviso!", e.message, "error"))
      .finally(f => setLoading(false));
  }

  //Função que puxa os dados do relatorio
  const carregarRelatorio = () => {
    const _errors = validarCampos(filtros, campos);

    if (_errors[1].length > 0) {
      setErrors(_errors[0]);
      return;
    }

    setLoading(true);
    relatorio_api.RelatorioGeradores(filtros)
      .then(response => {
        setDadosRelatorio(response.data);
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  const handleVolta = () => {
    setDadosRelatorio(null);
    setFiltros(initialStateFiltros());
  }

  useEffect(() => {

  }, []);

  if (dadosRelatorio) {
    return <RelatorioGeradores
      btnVoltar={handleVolta}
      filtros={filtros}
      dadosRelatorio={dadosRelatorio}
    />
  }

  return (
    <MainCard btnVoltarInTop={() => navigate(-1)}>
      {loading && <Loading />}
      <FiltroPrefeitura
        handleValue={handlePrefeitura}
      />
      <h4>Relatório dos Geradores</h4>
      <Row sm="12" md="6" lg="4">
        <Col md="12" lg="4">
          <TextField maxLength="150" label={"Razão social"} invalid={errors.razaoSocial ? true : false} value={filtros.razaoSocial} onChange={onChangeFiltros} name="razaoSocial" />
          {errors.razaoSocial && <span className={"form-control-label text-danger"}>{errors.razaoSocial.message}</span>}
        </Col>
        <Col md="12" lg="4">
          <TextField label={"CNPJ"} invalid={errors.cpfcnpj ? true : false} value={filtros.cpfcnpj} onChange={onChangeFiltros} name="cpfcnpj" maxLength="18" mask={mascaras.cnpjMask} />
          {errors.cpfcnpj && <span className={"form-control-label text-danger"}>{errors.cpfcnpj.message}</span>}
        </Col>
        <Col sm="12" md="6" lg="4">
          <TextField
            placeholder='Selecione'
            label={"Regional"}
            type={"select"}
            searchable
            name="regionalId_selected"
            options={optionsRegionais}
            value={filtros?.regionalId_selected}
            invalid={!!errors.regionalId_selected}
            onChange={onChangeSelected}
          />
        </Col>
        <Col sm="12" md="6" lg="4">
          <TextField
            maxLength={"200"}
            label={"Ramo de atividade"}
            type={"select"}
            searchable
            options={optionsRamos}
            name="RamoAtividade_selected"
            value={filtros.RamoAtividade_selected}
            invalid={!!errors.RamoAtividade_selected}
            onChange={onChangeSelected}
          />
        </Col>
        <Col sm="12" md="6" lg="4">
          <TextField
            name="status"
            label={"Status"}
            type={"select"}
            onChange={onChangeFiltros}
            options={optionsStatus}
            value={filtros.status}
            invalid={!!errors.status}
          />
        </Col>
        <Col sm="12" md="6" lg="3" style={{ marginTop: "1.875rem" }}>
          <Button
            className='w-100 fw-bold'
            color='info text-light'
            onClick={carregarRelatorio}>Gerar Relatório</Button>
        </Col>
      </Row>
    </MainCard>
  );
}

export default GeradoresRelatorio;